const homepageImageAltText = {
  'banner.webp': 'BugEraseX pest-control products for flies, rodents, and mosquitoes',
  'm_banner_f8d30347-17f1-4d0b-9495-42bbb3b4acf9.webp':
    'BugEraseX pest-control products for flies, rodents, and mosquitoes',
  'usa.webp': 'American-owned business',
  'shipping.webp': 'Fast shipping across the United States',
  'home.webp': 'Pest protection for homes and ranches',
  'free.jpg': 'Chemical-free pest protection',
  'safe.webp': 'Proven pest protection',
  'trusted.webp': 'Trusted by thousands of customers',
  'reviews_level.webp': '5 out of 5 stars',
  'pc_ads5-17.jpg': 'Pest-control solutions for flies, rodents, and mosquitoes on a ranch',
  'm_ads5-17.jpg': 'Pest-control solutions for flies, rodents, and mosquitoes on a ranch',
  'pc_brand.webp': 'American-owned business with a 30-day money-back guarantee',
  'm_brand.webp': 'American-owned business with a 30-day money-back guarantee',
};

document.querySelectorAll('main img').forEach((image) => {
  const source = image.currentSrc || image.src;
  const fileName = Object.keys(homepageImageAltText).find((name) => source.includes(name));

  if (fileName) image.alt = homepageImageAltText[fileName];
});

document.querySelectorAll('.why_wrap img').forEach((image) => {
  image.alt = '';
  image.setAttribute('aria-hidden', 'true');
});

const homepageHeroLink = document.querySelector('.hero__link');

if (homepageHeroLink && !homepageHeroLink.hasAttribute('aria-label')) {
  homepageHeroLink.setAttribute('aria-label', 'Shop BugEraseX pest-control products');
}

const initializeHomepageReviews = (attempt = 0) => {
  const reviews = document.querySelector('.reviews_wrap .swiper');

  if (!reviews) return;

  if (typeof window.Swiper !== 'function') {
    if (attempt < 20) setTimeout(() => initializeHomepageReviews(attempt + 1), 250);
    return;
  }

  if (reviews.swiper) {
    reviews.swiper.params.autoplay = {
      delay: 3500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    };
    reviews.swiper.autoplay?.start();
    return;
  }

  if (attempt < 20) {
    setTimeout(() => initializeHomepageReviews(attempt + 1), 250);
    return;
  }

  new window.Swiper(reviews, {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: false,
    speed: 700,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    observer: true,
    observeParents: true,
    pagination: {
      el: '.reviews_wrap .swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      600: { slidesPerView: 2, spaceBetween: 12 },
      900: { slidesPerView: 3, spaceBetween: 12 },
      1200: { slidesPerView: 5, spaceBetween: 10 },
    },
  });
};

let homepageReviewsTimer;
const scheduleHomepageReviews = () => {
  clearTimeout(homepageReviewsTimer);
  homepageReviewsTimer = setTimeout(initializeHomepageReviews, 750);
};

scheduleHomepageReviews();
document.addEventListener('DOMContentLoaded', scheduleHomepageReviews);
window.addEventListener('load', scheduleHomepageReviews);
document.addEventListener('shopify:section:load', scheduleHomepageReviews);
